// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2s_Fq","App-logo":"App_App-logo__1OUG0","App-logo-spin":"App_App-logo-spin__3jj4e","App-link":"App_App-link__1zUGJ"};